









































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../shared/services/mixin";
import {Component} from "vue-property-decorator";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {ContactStore} from "@/modules/contact/store";
import ContactSearch from "@/modules/contact/List/components/Search/index.vue";
import CommonStatusLabel from "@/shared/components/CommonStatusLabel/index.vue";
import {ContactParams} from "@/modules/contact/params";
import {CommonStatus} from "@/enums/status";

const columns = [
    {
        title: "Thao tác",
        dataIndex: "id",
        key: "id",
        width: 100,
        scopedSlots: { customRender: "action" },
        align: 'center',
        ellipsis: true
    },
    {
        title: "Tỉnh/Thành phố",
        dataIndex: ["province","name"],
        key: "province",
        scopedSlots: { customRender: "province" },
        width: 150,
        align: 'center',
        ellipsis: true
    },
    {
        title: "Phường/xã",
        dataIndex: ["district","name"],
        key: "district",
        width: 150,
        ellipsis: true
    },
    {
        title: "Bưu cục phát",
        dataIndex: ["postOffice","name"],
        key: "postOffice",
        width: 150,
        ellipsis: true
    },
    {
        title: "Shipper/Đối tác phát",
        dataIndex: ["partner","name"],
        key: "partner",
        width: 150,
        ellipsis: true
    },
    {
        title: "Số điện thoại",
        dataIndex: "phoneNumber",
        key: "phoneNumber",
        width: 100,
        ellipsis: true
    },
    {
        title: "Ghi chú/chỉ dẫn",
        dataIndex: "note",
        key: "note",
        width: 200,
        ellipsis: true
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      key: "status",
      width: 150,
      scopedSlots: { customRender: "status" },
      ellipsis: true
    }
]
@Component({
    name: "ContactList",
  computed: {
    CommonStatus() {
      return CommonStatus
    }
  },
    components: {CommonStatusLabel, ContactSearch}
})
export default class extends mixins(CommonMixin) {
    columns = [...columns];

    created() {
        const params = new ContactParams();
        ContactStore.updateParams(params);
        ContactStore.listContacts(params);
    }

    get contacts() {
      // console.log(Object.values(ContactStore.data));
        return Object.values(ContactStore.data);
    }

    get pagination() {
        return {
            current: ContactStore.meta.page,
            pageSize: ContactStore.meta.limit,
            total: ContactStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} tin tức`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
      ContactStore.listContacts({...ContactStore.params, page: pagination.current, limit: pagination.pageSize});
    }

    async onConfirm(id: any) {
        try {
            await ContactStore.deleteContact(id);
            const params = new ContactParams();
            await ContactStore.listContacts(params);
            this.$message.success("Xóa danh bạ thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Xóa danh bạ thất bại");
        }
    }
}
